import { DashboardTabModel, OldDashboardTabModel } from "./DashboardTab";
import { DashboardReportOptions } from "./DashboardReportOptions";

export interface Dashboard extends OldDashboard {
  id: number;
  title: string;
  iconClass: string;
  company: number;
  dashboardTabsJs: Array<DashboardTabModel>;
  tabsDisplay: TabsDisplay;
  showTabNavigation: boolean;
  companyShared: boolean;
  implementation: string;
  sortWeight: number;
  reportOptions: DashboardReportOptions;
  tabGroups?: TabGroup[];
}

export interface DashboardRequest extends Dashboard {
  overwrite?: boolean;
}

export type TabGroup = {
  uuid: string;
  title: string;
  isTabPlaceholder?: boolean;
};

export enum TabsDisplay {
  ROWS = "ROWS",
  DROPDOWN = "DROPDOWN",
}

interface OldDashboard {
  dashboardTabs: Array<OldDashboardTabModel>;
}

export type DashboardHistoryDto = {
  id: number;
  dashboardId: number;
  dashboardTabs: OldDashboardTabModel[];
  dashboardTabsJs: DashboardTabModel[];
  tabGroups: TabGroup[];
  reportOptions: DashboardReportOptions;
  changeBy: string;
  changeByCompanyRef: string;
  changeByCompanyTitle: string;
  changeOn: string;
}

export type PaginatedResponse<T> = {
  items: T[];
  pageInfo: OffsetPageInfo;
}

export type OffsetPageInfo = {
  skip: number;
  take: number;
  total: number;
}

export type DashboardPaginatedRequest = {
    dashboardId: number,
    skip?: number,
    take?: number,
}